function isWkHTMLToPDF() {
  return window.tfk.isPDF || false;
}
export default isWkHTMLToPDF;
